import { InferType, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

export const addressSchema = object({
  id: string().nullable(),
  buildingNumber: string().nullable(),
  buildingName: string().nullable(),
  subBuilding: string().nullable(),
  street: string().nullable(),
  secondaryStreet: string().nullable(),
  city: string().nullable(),
  province: string().nullable(),
  line1: string().required(requiredMessage),
  line2: string().nullable(),
  line3: string().nullable(),
  line4: string().nullable(),
  line5: string().nullable(),
  postalCode: string().required(requiredMessage),
  countryIso2: string().required(requiredMessage),
  label: string().nullable(),
  adminAreaName: string().nullable(),
})
  // https://github.com/jquense/yup/issues/1455#issuecomment-1219890988
  .default(undefined)

export type AddressSchemaType = InferType<typeof addressSchema>
